import $api from "@/frontend/shared/api/axios";

export async function getAllTagsForExpert({ id }: { id: number }) {
  const response = await $api.get("/tags/expert/" + id + "/extra");
  return response.data.data;
}
